export const GET_PRODUCT_REVIEW_REQUESTED  = 'GET_PRODUCT_REVIEW_REQUESTED';
export const GET_PRODUCT_REVIEW_SUCCESS    = 'GET_PRODUCT_REVIEW_SUCCESS';
export const GET_PRODUCT_REVIEW_FAILED     = 'GET_PRODUCT_REVIEW_FAILED';

export const GET_PRODUCT_DESCRIPTION_REQUESTED  = 'GET_PRODUCT_DESCRIPTION_REQUESTED';
export const GET_PRODUCT_DESCRIPTION_SUCCESS    = 'GET_PRODUCT_DESCRIPTION_SUCCESS';
export const GET_PRODUCT_DESCRIPTION_FAILED     = 'GET_PRODUCT_DESCRIPTION_FAILED';
